import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=4a744398"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a744398')) {
      api.createRecord('4a744398', component.options)
    } else {
      api.reload('4a744398', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=4a744398", function () {
      api.rerender('4a744398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Services.vue"
export default component.exports